import { useState, useEffect } from "react";
import { useAppZoom } from "../contexts/AppZoomContext";

const useEffectiveWidth = () => {
  const { zoomLevel } = useAppZoom();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return width / (zoomLevel / 100);
};

export default useEffectiveWidth;
